import { ApplicationConfig, provideZoneChangeDetection, provideAppInitializer, inject, isDevMode, ErrorHandler } from '@angular/core';
import { AppTokenStorageService } from './token-storage.service';
import { environment } from '../environments/environment';
import { forkJoin, Observable } from 'rxjs';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { routes } from './app.routes';
import { SessionService } from './session/session.service';
import { SP_API_URL, TOKEN_STORAGE, authInterceptor, apiErrorInterceptor } from 'sp-client';
import { SP_IMAGE_URL } from './core/image-url.token';
import { TenantService } from './services/tenant.service';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import * as Sentry from "@sentry/angular";
import { FullscreenOverlayContainer } from '@angular/cdk/overlay';
import { OverlayContainer } from '@angular/cdk/overlay';


export function initializeSession(): Observable<unknown> {
  const sessionService = inject(SessionService);
  inject(TenantService);
  return sessionService.restore();
}

export function initializeTranslate(): Observable<unknown> {
  const translate = inject(TranslateService);
  return translate.use('de');
}

export function initializeApp(): Observable<unknown> {
  return forkJoin([
    initializeSession(),
    initializeTranslate()
  ]);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),

    provideAppInitializer(initializeApp),

    { provide: TOKEN_STORAGE, useExisting: AppTokenStorageService },

    provideHttpClient(withFetch(), withInterceptors([authInterceptor, apiErrorInterceptor])),

    { provide: SP_API_URL, useValue: environment.apiUrl ?? `https://api-${environment.tenantSlug}.simply-pos.app/api/`, },
    { provide: SP_IMAGE_URL, useValue: environment.imageUrl ?? `https://api-${environment.tenantSlug}.simply-pos.app/` },
    provideAnimationsAsync(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
      fallbackLang: 'de'
    }),
    provideLuxonDateAdapter(),
    provideCharts(withDefaultRegisterables()), 
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
  ]
};
